import { render, staticRenderFns } from "./add_com.vue?vue&type=template&id=7317fdfa&scoped=true&"
import script from "./add_com.vue?vue&type=script&lang=js&"
export * from "./add_com.vue?vue&type=script&lang=js&"
import style0 from "./add_com.vue?vue&type=style&index=0&id=7317fdfa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7317fdfa",
  null
  
)

export default component.exports